import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import cartReducer from './components/reducers/cartReducer';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import Amplify from 'aws-amplify';
/*import config from './aws-exports';*/
/*import config from './aws-config-dev';*/
import config from './aws-config-test';

Amplify.configure(config);

const store = createStore(cartReducer);

ReactDOM.render(
  <React.StrictMode>
  	<BrowserRouter>
	    <Provider store={store}>
        <App />
      </Provider>
	  </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
serviceWorker.register();
